import { styled } from '@linaria/react';
import { colors, fonts, layout, space } from '../../theme/tokens';

export const MonthWrapper = styled.div`
  width: 100%;
`;

export const MonthHeader = styled.div`
  display: grid;
  grid-template-columns: ${space[6]} 1fr ${space[6]};
  align-items: center;
  padding: ${space[2]} 0 ${space[3]};
  font-family: ${fonts.body};
  font-size: ${fonts.size.md};
  font-weight: ${fonts.weight.semiBold};
  color: ${colors.fontPrimary};

  &[data-no-nav] {
    display: block;
    text-align: left;
    padding-left: ${space[3]};
  }
`;

export const MonthLabel = styled.span`
  text-align: center;
`;

export const NavSlot = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const NavButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${space[6]};
  height: ${space[6]};
  border: none;
  background: transparent;
  border-radius: ${layout.borderRadiusFull};
  color: ${colors.fontPrimary};
  cursor: pointer;
  padding: 0;
  transition: background-color 0.15s ease;

  &:disabled {
    color: ${colors.borderGrey};
    cursor: not-allowed;
  }

  &:focus-visible {
    outline: 2px solid ${colors.primary};
    outline-offset: 2px;
  }

  &:hover:not(:disabled) {
    background: ${colors.lighterGrey};
  }
`;

export const WeekdayRow = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 2px;
  margin-bottom: ${space[1]};
`;

export const WeekdayLabel = styled.span`
  text-align: center;
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  font-weight: ${fonts.weight.semiBold};
  color: ${colors.fontSecondary};
  text-transform: uppercase;
  padding: ${space[1]} 0;
`;

export const DaysGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 0;
`;

export const DayWrapper = styled.div`
  &:hover {
    z-index: 1;
  }
`;
